<header-title [model]="headerTitle"></header-title>

<div class="row">
    <div class="col">
        <button class="btn btn-primary" type="button" [routerLink]="['/question/add']">Add New Question</button>
    </div>
</div>

<section class="panel">
    <div class="row my-3">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h3 class="panel-title text-gray-600">Existing Questions</h3>
            </header>
        </div>
        <div class="col col-md-6 pt-3">
            <div class="row align-items-center">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter Questions:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th width="70%">Title</th>
                        <th width="13%">Response Type</th>
                        <th width="13%" class="text-center">Weighting</th>
                        <th width="13%" class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let question of questionList;index as i">
                        <td>{{i+1}}</td>
                        <td title="{{question.title | htmlToText}}" data-toggle="tooltip">{{question.title | htmlToText}}</td>
                        <td>{{question.responseType}}</td>
                        <td class="text-center">{{question.weighting}}</td>
                        <td class="actions text-center">
                            <a [routerLink]="['/question', question.id]" class="mb-1 mt-1 me-2 text-primary"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
